export default "__VITE_ASSET__mangqq7H__"